// src/components/shared/ErrorBoundary.jsx
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log internally — never expose stack traces to the user
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: '32px',
            background: 'var(--c-surface-2)',
            border: '1px solid rgba(235,87,87,0.25)',
            borderRadius: '12px',
            textAlign: 'center',
            color: 'white',
          }}
        >
          <p style={{ fontSize: '18px', fontWeight: 700, marginBottom: '8px' }}>
            Something went wrong
          </p>
          <p style={{ fontSize: '13px', color: 'var(--c-grey)', marginBottom: '20px' }}>
            This section couldn't load. Try refreshing or going back to the home screen.
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '8px 20px', borderRadius: '8px', fontSize: '13px',
                backgroundColor: 'var(--c-blue)', color: 'white', border: 'none', cursor: 'pointer',
              }}
            >
              Refresh
            </button>
            <button
              onClick={() => { window.location.href = '/'; }}
              style={{
                padding: '8px 20px', borderRadius: '8px', fontSize: '13px',
                backgroundColor: 'transparent', color: 'var(--c-grey)',
                border: '1px solid var(--c-border)', cursor: 'pointer',
              }}
            >
              Go Home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export const withErrorBoundary = (Component) => {
  const Wrapped = (props) => (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );
  Wrapped.displayName = `WithErrorBoundary(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
};

export default ErrorBoundary;
